/**
 * memoru
 */
export const multimediaCategoryType = [
  {
    title: "",
    value: "",
  },
  {
    title: "写真",
    value: "photo",
  },
  {
    title: "動画",
    value: "movie",
  },
];

export const mediaFormatType = [
  {
    title: "",
    value: "",
  },
  {
    title: "データ",
    value: "data",
  },
  {
    title: "プリント",
    value: "print",
  },
];

export const isPublishedItems = [
  { title: "", value: undefined },
  { title: "公開中", value: true },
  { title: "非公開中", value: false },
];
